// extracted by mini-css-extract-plugin
export default {"root":"PortfolioTable_root__6RBUg"};